import { render, staticRenderFns } from "./my_life_record.vue?vue&type=template&id=179ddc4f&scoped=true"
import script from "./my_life_record.vue?vue&type=script&lang=js"
export * from "./my_life_record.vue?vue&type=script&lang=js"
import style0 from "./my_life_record.vue?vue&type=style&index=0&id=179ddc4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179ddc4f",
  null
  
)

export default component.exports